// 본문(HTML) 렌더 파이프라인 구간별 소요 계측 하네스.
// 기본 비활성 — `window.__mailPerfEnabled === true` 일 때만 기록한다(프로덕션/일반 실행 무영향).
// 측정 e2e 스펙(perf-mailview)이 플래그를 켜고 `window.__mailPerf` 를 읽어 구간별 수치를 수집한다.

export type MailPerfMode = 'html' | 'element'

export interface MailPerfRecord {
  messageId: string
  // 본문 반영 방식: 'html' = getSafeHTML + innerHTML 주입(문자열 재파싱),
  //               'element' = getSafeElement + ref.appendChild(DOM 직접 삽입).
  mode: MailPerfMode
  // reqBody 디스패치 → 본문 데이터 도착(onSetDetails).
  fetchMs: number
  // getSafeX 호출 → resolve(DOM 변환 + 'html' 모드의 outerHTML 직렬화 포함).
  transformMs: number
  // bake 완료 → 본문 div ref 콜백 발화(React commit + DOM 삽입).
  commitMs: number
  // bake 완료 → 다음 paint 완료(화면 표시).
  paintMs: number
  bodyBytes: number
  elementCount: number
}

interface PerfWindow extends Window {
  __mailPerf?: MailPerfRecord[]
  __mailPerfEnabled?: boolean
}

export function isMailPerfEnabled(): boolean {
  return typeof window !== 'undefined' && (window as PerfWindow).__mailPerfEnabled === true
}

export function recordMailPerf(rec: MailPerfRecord): void {
  if (!isMailPerfEnabled()) return
  const w = window as PerfWindow
  if (w.__mailPerf == null) w.__mailPerf = []
  w.__mailPerf.push(rec)
  console.log('MAIL_PERF ' + JSON.stringify(rec))
}

// bake 완료 시각(bakeEnd) 기준으로 commit·paint 를 측정해 한 건의 레코드로 기록한다.
// commitAt 은 본문 div ref 콜백에서 채워지며(없으면 bakeEnd 로 폴백), paint 는 더블 rAF 로 측정한다.
export function schedulePaintMeasure(
  base: Omit<MailPerfRecord, 'commitMs' | 'paintMs'>,
  bakeEnd: number,
  getCommitAt: () => number | undefined,
): void {
  if (!isMailPerfEnabled()) return
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const commitAt = getCommitAt()
      recordMailPerf({
        ...base,
        commitMs: (commitAt ?? bakeEnd) - bakeEnd,
        paintMs: performance.now() - bakeEnd,
      })
    })
  })
}
